jQuery(document).ready(function($) { 
  
    /////////////////////
      /// MENU MOBILE /////
    ////////////////////

    var menu_mobile = $('#footer_menu_4').clone();
    var smenu_1 = $("#footer_menu_1").clone().html();
    var smenu_2 = $("#footer_menu_2").clone().html();
    var smenu_3 = $("#footer_menu_3").clone().html();

    var l_window = $( window ).width();

   
    menu_mobile.prepend(smenu_3);
    menu_mobile.prepend(smenu_2);
    menu_mobile.prepend(smenu_1);
    menu_mobile.append('<li><a href="http://www.smile-lesalon.com/smile-en-france/">Tous les smile</a></li>');
    
    // menu_mobile.append(menu_rs);
    menu_mobile.slicknav({
      duration:300,
      prependTo : ".HeaderMobile",
      beforeOpen:move_body,
      beforeClose:move_body,
      openedSymbol:">",
      closedSymbol:">"
    });


    function move_body(){

    if($('.slicknav_btn').hasClass('slicknav_open')){
      $('body').addClass('move_to_right');
    }else{
      $('body').removeClass('move_to_right');
    }
  }



  /***********/
    /* GALERY SLICK  */
  /***********/
        $('.GallerySlick').slick({
      //setting-name: setting-value
          arrows:true,
          rows:2,
          slidesPerRow:3,
          activateRows:true,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
             rows:2,
             slidesPerRow:2,
             dots: true,
             arrows:false
            }
          },
          {
            breakpoint: 600,
            settings: {
             slidesToShow: 1,
             rows:1,
             slidesPerRow:1,
             dots: true,
             arrows:false,
             slidesToScroll: 1,
            }
        }
      ]

      });

    $('.GallerySlick').slickLightbox({
        itemSelector        : 'a',
        caption: "caption"
    });


  /***********/
    /* LIGHTBOX  TEMOIGNAGE  */
  /***********/

      $('a.js-single-temoignage').featherlight({
        otherClose:'button.Lightbox-Close',
        targetAttr:'featherlight-target'
    });


  /***********/
    /* LIGHTBOX VISITE  */
  /***********/


    $('a.js-lightbox-pm').featherlight({
        targetAttr: 'href',
        otherClose:'button.Lightbox-Close',
        afterOpen: function(event){
        console.log(this); 
        $('.SlideGalerieVisite').slick({
          dots: true,
          arrows:true
      });

      },
      afterClose: function(event){
          $('.SlideGalerieVisite').slick('unslick');
      }



         



    });



   /***********/
    /* SALON  */
  /***********/


  
      // Handler for .ready() called.
        var ContainerBG = $('.ContainerBG');
        var Wrapper = $('.PageParent');

        // var Item1 = $('.js-item-1');
        // var Item2 = $('.js-item-2');
        // var Item3 = $('.js-item-3');
        var JSELTSVG = $('.js-elt-svg');
       

        var hori_base = 50;
        var verti_base = 55;
        var diff_verti = 2;
        var diff_hori = 2;


        var base = hori_base+'% '+verti_base+'%';  $('.specialPAGEPARENT').css("background-position", base);
        var haut_gauche = parseInt(hori_base-diff_hori)+'% '+parseInt(verti_base-diff_verti)+'%';
        var haut_droite = parseInt(hori_base+diff_hori)+'% '+parseInt(verti_base-diff_verti)+'%';

        var bas_gauche = parseInt(hori_base-diff_hori)+'% '+parseInt(verti_base+diff_verti)+'%';
        var bas_droite = parseInt(hori_base+diff_hori)+'% '+parseInt(verti_base+diff_verti)+'%';

        if ($( window ).width() > 1164){

          var MaTween;
          // HAUT GAUCHE 
          $( ".js-item-1" ).hover(
          function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': haut_gauche}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 1, {x:'20px', y:'20px', ease: Power1.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:'43px', y:'21px', ease: Power2.easeOut});

           // $('.ContainerBG').addClass( "hover" );
          }, function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': base}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 0.5, {x:0, y:0, ease: Power4.easeOut});
             MaTween = TweenMax.to(JSELTSVG, 0.8, {x:0, y:0, ease: Power2.easeOut});
          }
        );

          // HAUT DROTIE 
        $( ".js-item-2" ).hover(
          function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': haut_droite}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 1, {x:'-20px', y:'20px', ease: Power1.easeOut});
             MaTween = TweenMax.to(JSELTSVG, 0.8, {x:'-43px', y:'21px', ease: Power2.easeOut});
   
           // $('.ContainerBG').addClass( "hover" );
          }, function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': base}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 0.5, {x:0, y:0, ease: Power4.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:0, y:0, ease: Power2.easeOut});
          }
        );

        // BAS GAUCHE 
        $( ".js-item-3" ).hover(
          function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': bas_gauche}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 1, {x:'20px', y:'-20px', ease: Power1.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:'43px', y:'-21px', ease: Power2.easeOut});
           // $('.ContainerBG').addClass( "hover" );
          }, function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': base}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 0.5, {x:0, y:0, ease: Power4.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:0, y:0, ease: Power2.easeOut});
          }
        );

        // BAS DROITE
        $( ".js-item-4" ).hover(
          function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': bas_droite}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 1, {x:'-20px', y:'-20px', ease: Power1.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:'-43px', y:'-21px', ease: Power2.easeOut});
           // $('.ContainerBG').addClass( "hover" );
          }, function() {
            MaTween = TweenMax.to(ContainerBG, 0.8, {css:{'background-position': base}, ease: Power2.easeOut});
            MaTween = TweenMax.to(Wrapper, 0.5, {x:0, y:0, ease: Power4.easeOut});
            MaTween = TweenMax.to(JSELTSVG, 0.8, {x:0, y:0, ease: Power2.easeOut});
          }
        );

        function desactivate_hover(){
           $('.js-item-1, .js-item-2,.js-item-3,.js-item-4').unbind('mouseenter mouseleave');
        }


        $( "#Item1 a" ).click(function(evt) {
          desactivate_hover();
          var link = $(this).attr("href");
          var other_block = $('.js-item-2, .js-item-3,.js-item-4');
              setTimeout(function() {
                  window.location.href = link;
              }, 500);
              MaTween = TweenMax.to(ContainerBG, 0.5, {css:{'background-position': '15% 15%'}, ease: Power2.easeOut});
             // MaTween = TweenMax.to(JSELTSVG, 0.2, {opacity:0, ease: Power2.easeOut});
              MaTween = TweenMax.to(other_block, 0.2, {opacity:0, ease: Power2.easeOut});
              evt.preventDefault();

        });

        $( "#Item2 a" ).click(function(evt) {
          desactivate_hover();
          var link = $(this).attr("href");
           var other_block = $('.js-item-1, .js-item-3,.js-item-4');

              setTimeout(function() {
                  window.location.href = link;
              }, 500);
              MaTween = TweenMax.to(ContainerBG, 0.5, {css:{'background-position': '85% 15%'}, ease: Power2.easeOut});
              MaTween = TweenMax.to(other_block, 0.2, {opacity:0, ease: Power2.easeOut});
              evt.preventDefault();

        });

        $( "#Item3 a" ).click(function(evt) {
          desactivate_hover();
          var link = $(this).attr("href");
           var other_block = $('.js-item-1, .js-item-2,.js-item-4');
              setTimeout(function() {
                  window.location.href = link;
              }, 500);
              MaTween = TweenMax.to(ContainerBG, 0.5, {css:{'background-position': '15% 85%'}, ease: Power2.easeOut});
              MaTween = TweenMax.to(other_block, 0.2, {opacity:0, ease: Power2.easeOut});
              evt.preventDefault();

        });

        $( "#Item4 a" ).click(function(evt) {
          desactivate_hover();
          var link = $(this).attr("href");
          var other_block = $('.js-item-1, .js-item-2,.js-item-3');
              setTimeout(function() {
                  window.location.href = link;
              }, 500);
              MaTween = TweenMax.to(ContainerBG, 0.5, {css:{'background-position': '85% 85%'}, ease: Power2.easeOut});
             MaTween = TweenMax.to(other_block, 0.2, {opacity:0, ease: Power2.easeOut});
              evt.preventDefault();

        });
      }


       /***********/
    /* CLASSIQUEPAGE  */
  /***********/

    
    //   var WrapperPage = $('.wrapper_in_page');
    //   var Hwindow = $(window).height();

    //   if (WrapperPage.length ) {

    //   $( window ).scroll(function() {

    //     var scroll = $(window).scrollTop();
    //     var PositionYBottomWrapper = WrapperPage.offset().top + WrapperPage.outerHeight(true);
     
    //    if (parseInt(scroll+ Hwindow) > PositionYBottomWrapper){

    //    }else{
    //      ContainerBG.css('top', scroll);
         
    //    }

    //  });

    // }

      // console.log(scroll);
      // console.log(Hwindow);


     /***********/
    /* HOME PAGE  */
  /***********/

    
  $( ".js-Btn-next-section" ).click(function(evt) {
      var page = $(this).attr('href'); // ELT cible
      var speed = 450; // Durée de l'animation (en ms)
      var top = $(page).find('.HomeBigSection-inner').offset().top - 250; // 250 = HEADER ?
      $('html, body').animate( { scrollTop: top }, speed ); // Go
     evt.preventDefault();

   });

  /***********/
    /* NAV BOTTOM TO TOP */
  /***********/

    var distance = $('.js-site-nav').offset().top,
    $window = $(window);

    $window.scroll(function() {
      $('.js-site-nav').toggleClass('fixedtop', $window.scrollTop() >= distance-100)
  });

    $('.FooterConfiance-Slide').slick({
        //setting-name: setting-value
        slidesToShow:3,
        slidesToScroll: 3,
         dots: false,
        responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
            arrows:false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows:false
          }
        }
      ]
      });



      /***********/
    /* WOW EFFECT  */
  /***********/



    //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();



    /***********/
    /* ACTUS  */
  /***********/ 

      

      function theme_load_portfolio_content(){
          var slideToSpeed = 500;
          var slideUpSpeed = 700;
          var $easingType = 'easeOutQuart';
          var $close_button = $('#close');
          var $load_items = $('a.load-ajax-content');
          var hash = window.location.hash.substr(1);

        var h_header = $("#masthead").height()+70;

          $('a').each(function () {
              var $this = $(this);
              var rel = $this.attr('rel');
              var href = $this.attr('href');
              if (hash == rel) {
                 // console.log($("#blog")[0].scrollHeight);

                  $('html,body').animate({ scrollTop: $("#blog").offset().top-h_header},600,'swing',function(){
                      loadContent(href);
                  }
                );


              }
          });

         $( "body" ).on( "click", "a.load-ajax-content", function() {
            $load_items.removeClass('active');
            $(this).addClass('active');
            var $this = $(this);
            var rel = $this.attr('rel');
            var href = $this.attr('href');
            var h_header = $("#masthead").height()+70;

            if (window.location.hash.substr(1) == rel) {
                 // console.log($("#blog").offset().top-50);
               
                $('html,body').animate({ scrollTop: $("#blog").offset().top-h_header},600,'swing');

            } else {
                window.location.hash = rel;
                
                $('html,body').animate({ scrollTop: $("#blog").offset().top-h_header},600,'swing',function(){
                       $close_button.fadeOut(100);
                        $('#page-ajax-content').slideUp(slideUpSpeed, function () {
                            loadContent(href);
                        });
                    }

                  );
            }
            return false;
        });
        $close_button.click(function () {

           // $load_items.removeClass('active');
            $close_button.fadeOut(500);
           
            $('#page-ajax-content').slideUp(500, function(){
                //window.location.hash = '';
            });
           
           
            return false;
        });

        function loadContent(href) {
            $('#loader').slideDown(300);
            var LoadContentWrapper = href + ' .pageloader-inner'; // contenu de la page chargé //

            $('#pageloader').delay(500).queue(function () {

                $(this).load(LoadContentWrapper, function () {
                
                    $('#loader').slideUp(300);
                    $('#page-ajax-content').slideDown(slideUpSpeed, function () {
                        $close_button.fadeIn(500);
                    });
        
                });
               // $(this).dequeue();
                $(this).clearQueue();
            });
        }
    };

     if($('body').hasClass('blog')) { theme_load_portfolio_content(); }



}); // fin ready menu